<script>
	export let name;
</script>
<main>
	<h1>Anker Repair</h1>

	<font size = "5">This is my new shop! Ultra cheap prices for repairing anything! 
		Just shoot me an email at:  orioncrespo10@gmail.com</font><br />
	
	

	


	<br>
	Contact Orion for prices to get your NFT listed on our page.

</main>
<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}
	h1 {
		color: black;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}
	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>

		<nft-card
  tokenAddress="0x495f947276749ce646f68ac8c248420045cb7b5e"
  tokenId="74910965659129920827967912483173887147949622782888675597174626338947519741953"
  network="mainnet"
  referrerAddress="0x495f947276749ce646f68ac8c248420045cb7b5e"
  >
</nft-card>
